export const BASE_PATH = '/travel2';
export const API_PATH = BASE_PATH + '/backend/api';
export const API_BASE_URL = 'https://www.agentriplanner.com' + API_PATH;